import React from 'react'
import {Link} from 'react-router-dom'
const Home = () => {
  return (
    <div className="home flex flex-col items-center justify-center">
      <img
        className="home-logo"
        src="/images/logo.png"
        alt="Foam UI Logo"
      />
      <h1 className="home-title">Foam UI</h1>
      <p className="home-description">
        A simple and lightweight CSS library with ready to use UI components for
        developing fast and interactive websites.
      </p>
      <Link to="/main">
        <button className="home-btn">Get started</button>
      </Link>
    </div>
  )
}

export default Home